/**
 * Impl dos use cases de Oferta + Diário de classe (enrollment).
 *
 * @since G.5.19
 */
import type { Page } from '@/domain/model/Page';
import type {
  Oferta, OfertaStatus, DiarioAula,
  CreateOfertaCommand, UpdateOfertaCommand, DiarioAulaCommand,
} from '@/domain/model/Oferta';
import type { OfertaGateway, DiarioAulaGateway, ListOfertasParams } from '@/application/port/out/OfertaGateways';
import type {
  ListOfertasUseCase, CreateOfertaUseCase, UpdateOfertaUseCase, MudarStatusOfertaUseCase,
  ListAulasUseCase, RegistrarAulaUseCase, AtualizarAulaUseCase, ExcluirAulaUseCase,
} from '@/application/port/in/OfertaUseCase';

export class ListOfertas implements ListOfertasUseCase {
  constructor(private readonly g: OfertaGateway) {}
  execute(p: ListOfertasParams): Promise<Page<Oferta>> { return this.g.list(p); }
}
export class CreateOferta implements CreateOfertaUseCase {
  constructor(private readonly g: OfertaGateway) {}
  execute(cmd: CreateOfertaCommand): Promise<Oferta> { return this.g.create(cmd); }
}
export class UpdateOferta implements UpdateOfertaUseCase {
  constructor(private readonly g: OfertaGateway) {}
  execute(id: string, cmd: UpdateOfertaCommand): Promise<Oferta> { return this.g.update(id, cmd); }
}
export class MudarStatusOferta implements MudarStatusOfertaUseCase {
  constructor(private readonly g: OfertaGateway) {}
  execute(id: string, status: OfertaStatus): Promise<Oferta> { return this.g.mudarStatus(id, status); }
}

export class ListAulas implements ListAulasUseCase {
  constructor(private readonly g: DiarioAulaGateway) {}
  execute(ofertaId: string, page?: number, size?: number): Promise<Page<DiarioAula>> { return this.g.list(ofertaId, page, size); }
}
export class RegistrarAula implements RegistrarAulaUseCase {
  constructor(private readonly g: DiarioAulaGateway) {}
  execute(ofertaId: string, cmd: DiarioAulaCommand): Promise<DiarioAula> { return this.g.registrar(ofertaId, cmd); }
}
export class AtualizarAula implements AtualizarAulaUseCase {
  constructor(private readonly g: DiarioAulaGateway) {}
  execute(ofertaId: string, id: string, cmd: DiarioAulaCommand): Promise<DiarioAula> { return this.g.atualizar(ofertaId, id, cmd); }
}
export class ExcluirAula implements ExcluirAulaUseCase {
  constructor(private readonly g: DiarioAulaGateway) {}
  execute(ofertaId: string, id: string): Promise<void> { return this.g.excluir(ofertaId, id); }
}
